export default "__VITE_ASSET__usmHgzTW__"